export function pad(n: number, width: number): string {
    const st = n + '';
    return st.length >= width ? st : new Array(width - st.length + 1).join('0') + st;
}

export function getFrameIndex(date: Date) {
    return (date.getHours() * 12) + Math.floor(date.getMinutes() / 5) + 1;
}